export default {"src":"/_next/static/media/logo.1a57336d.svg","height":26,"width":118};